import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BillingInvoice, BillingInvoiceCreate, BillingInvoiceFilter } from '../data/billingInvoice';

export function createBillingInvoiceService(client: AxiosInstance) {
  return createCrudService<BillingInvoice, BillingInvoiceCreate, BillingInvoiceFilter>(
    client,
    '/tenancy/BillingInvoice',
    'id',
  );
}

export type BillingInvoiceService = CrudService<BillingInvoice, BillingInvoiceCreate, BillingInvoiceFilter>;
